import { render, staticRenderFns } from "./tableHistory.vue?vue&type=template&id=5627c82e&scoped=true"
import script from "./tableHistory.vue?vue&type=script&lang=js"
export * from "./tableHistory.vue?vue&type=script&lang=js"
import style0 from "./tableHistory.vue?vue&type=style&index=0&id=5627c82e&prod&scoped=true&lang=css"
import style1 from "./tableHistory.vue?vue&type=style&index=1&id=5627c82e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5627c82e",
  null
  
)

export default component.exports